<div class="sh-main-layout">
  <div class="sh-main-layout__nav">
    @if (logoContent) {
      <div class="sh-main-layout__nav__head">
        <ng-container *ngTemplateOutlet="logoContent"></ng-container>
      </div>
    }
    <div class="sh-main-layout__nav__links">
      <ng-container *ngTemplateOutlet="linksContent"></ng-container>
    </div>
  </div>
  <div class="sh-main-layout__content sh-scroll-container" [class]="scrollPadding$ | async">
    <ng-container *ngTemplateOutlet="mainContent"></ng-container>
  </div>
  <ng-content></ng-content>
</div>
